

const BASE_RATE = 15;


export default BASE_RATE;